// Release-Stufen (muss zur Backend-Logik api/release_stages.py passen).
export const RELEASE_STAGES: { value: string; title: string }[] = [
  { value: "testing", title: "Testing" },
  { value: "alpha", title: "Alpha" },
  { value: "beta", title: "Beta" },
  { value: "latest", title: "Latest" },
];
